module.exports = __webpack_public_path__ + "img/14_12.cccf38ae.png";